import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

import {
  Template, TemplateCreate,
  TemplateSearchParams,
  TemplateUpdate
} from '../../interfaces/template.interface';

export const TemplateActions = createActionGroup({
  source: 'Templates',
  events: {
    Get: props<{ id: string }>(),
    'Get success': props<{ template: Template }>(),
    'Get failure': props<{ error: HttpErrorResponse }>(),

    Search: props<{ params: TemplateSearchParams }>(),
    'Search success': props<{ templates: Template[] }>(),
    'Search failure': props<{ error: HttpErrorResponse }>(),

    Create: props<{ payload: TemplateCreate }>(),
    'Create success': props<{ payload: Template }>(),
    'Create failure': props<{ error: HttpErrorResponse }>(),

    Update: props<{ templateId: string; payload: TemplateUpdate }>(),
    'Update success': props<{ payload: Template }>(),
    'Update failure': props<{ error: HttpErrorResponse }>(),

    Delete: props<{ id: string }>(),
    'Delete success': props<{ id: string }>(),
    'Delete failure': props<{ error: HttpErrorResponse }>(),

    Duplicate: props<{ id: string }>(),
    'Duplicate success': props<{ payload: Template }>(),
    'Duplicate failure': props<{ error: HttpErrorResponse }>(),

    'Reset error': emptyProps(),

    'Clear state': emptyProps(),
  },
});
